// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".youtubevideo-container{height:100%;background:#000}", "",{"version":3,"sources":["webpack://./youtubeVideo.vue"],"names":[],"mappings":"AACA,wBACI,WAAA,CACA,eAAA","sourcesContent":["\n.youtubevideo-container {\n    height: 100%;\n    background: black;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
